// WorkOrdersStatusFilter.tsx — Sprint 11. Inline pill bar that
// drives the status filter applied to the table below.
import React from 'react';
import { Button, Card, Space, Typography } from 'antd';
import { STATUS_FILTERS, type StatusFilter } from './workOrderTypes';

const { Text } = Typography;

export interface WorkOrdersStatusFilterProps {
  value:    StatusFilter;
  onChange: (next: StatusFilter) => void;
}

export const WorkOrdersStatusFilter: React.FC<WorkOrdersStatusFilterProps> = ({ value, onChange }) => (
  <Card style={{ marginBottom: 16, borderRadius: 10 }} size="small">
    <Space>
      <Text strong>Filter by status:</Text>
      {STATUS_FILTERS.map(s => (
        <Button
          key={s}
          size="small"
          type={value === s ? 'primary' : 'default'}
          onClick={() => onChange(s)}
        >
          {s === 'ALL' ? 'All' : s.replace('_', ' ')}
        </Button>
      ))}
    </Space>
  </Card>
);
